import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Tecno from "./components/About/Tecno";
import Atlantis from "./components/About/Atlantis";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Galleria from "./components/Galleria/Galleria";
import Privacy from "./components/Privacy";
import { SpeedInsights } from "@vercel/speed-insights/react"; //Misurazione della velocità del sito su Vercel
import { Analytics } from "@vercel/analytics/react"; //Statistiche del sito su Vercel
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/progetti" element={<Projects />} />
          <Route path="/tecno" element={<Tecno />} />
          <Route path="/atlantis" element={<Atlantis />} />
          <Route path="/galleria" element={<Galleria />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
        <SpeedInsights />
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
